import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BehaviorSubject, Observable } from "rxjs";
import { withLatestFrom, map } from "rxjs/operators";

import { UserSummaryContactService } from "@onsip/common/services/api/resources/userSummaryContact/user-summary-contact.service";
import { WebCallTopicRep } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic-rep";
import { ListPickerItem } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker-item";

@Component({
  selector: "onsip-rep-list-view",
  templateUrl: "rep-list-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RepListViewComponent implements OnInit {
  @Input() set reps(reps: Array<WebCallTopicRep>) {
    this._repListItems.next(reps);
  }
  private _repListItems = new BehaviorSubject<Array<WebCallTopicRep>>([]);
  repListItems!: Observable<Array<ListPickerItem>>;

  constructor(private userSummaryContact: UserSummaryContactService) {}

  ngOnInit() {
    this.repListItems = this._repListItems.asObservable().pipe(
      withLatestFrom(this.userSummaryContact.state.pipe(map(substate => substate.state))),
      map(([inputReps, users]) =>
        inputReps
          .filter(webCallTopicRep => {
            const found = users[webCallTopicRep.repId];
            return !!found;
          })
          .map(webCallTopicRep => {
            const found = users[webCallTopicRep.repId];
            if (!found) throw new Error("no user found for topic rep" + webCallTopicRep.repId);
            return {
              name: found.contactName,
              id: webCallTopicRep.repId + "",
              avatarUrl: found.userAvatarUrl
            };
          })
      )
    );
  }
}
